import { Component, Inject, OnDestroy } from '@angular/core';
import { Utils } from 'core/utils';
import { Subscription } from 'rxjs';

import { Progress, ProgressService } from '../progress.service';

@Component({
    selector: 'progress-navigation',
    templateUrl: './progress-navigation.component.html',
    styleUrls: ['./progress-navigation.component.scss'],
    standalone: false
})
export class ProgressNavigationComponent implements OnDestroy
{
  public currentProgress: Progress;
  public progressList: Array<Progress>;
  public trackById: (index: number, item: any) => any = Utils.trackById;

  private progressService: ProgressService;
  private progressChangedSubscription: Subscription;

  constructor(@Inject(ProgressService) progressService: ProgressService)
  {
    this.progressService = progressService;
    this.currentProgress = this.progressService.getCurrentProgress();
    this.progressChangedSubscription =
        this.progressService.progressChanged.subscribe((progress) => {
          this.currentProgress = progress;
        });
  }

  public ngOnDestroy(): void
  {
    this.progressChangedSubscription.unsubscribe();
  }

  public getProgressList(): Array<Progress>
  {
    return this.progressService.getProgressList();
  }
}
